"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithLoadingOverlay = exports.LoadingGlobal = exports.LoadingOverlay = exports.Loading = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const LoadingInner = app_1.styled.div `
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &:after {
    content: '';
    display: block;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    animation: rotate 1s linear 0s infinite;
    border: ${(theme) => `0.1em solid ${theme.colors.gray.light}`};
    border-left: ${(theme) => `0.1em solid ${theme.colors.primary}`};
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
exports.Loading = (0, react_1.forwardRef)((_a, ref) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return ((0, jsx_runtime_1.jsx)(LoadingInner, Object.assign({}, props, { ref: ref, css: [
            size &&
                (0, app_1.css) `
            font-size: ${size};
          `,
        ] })));
});
exports.LoadingOverlay = (0, app_1.styled)(exports.Loading) `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100000;
`;
exports.LoadingGlobal = (0, app_1.styled)(exports.LoadingOverlay) `
  position: fixed;
`;
function WithLoadingOverlay({ children, loading, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [loading ? (0, jsx_runtime_1.jsx)(exports.LoadingOverlay, {}) : null, children] }));
}
exports.WithLoadingOverlay = WithLoadingOverlay;
